// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alert[data-v-2d83e593] .close {\n  margin-left: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
